export const getPostsMap = (productWithCourier) => {
	const postsMap = new Map();

	const defaultPosts = productWithCourier.default_posts;
	const activePosts = productWithCourier.active_posts.filter(
		(post) => !defaultPosts.some((defaultMail) => defaultMail._id === post._id),
	);

	const allPosts = [...defaultPosts, ...activePosts];

	allPosts.forEach((post) => {
		postsMap.set(post.name, post);
	});

	return postsMap;
};
